export default function useDocsLink(): string {
  return "https://docs.decentriq.com";
}
